import { gql } from "@apollo/client";

export const GET_CLIENT_MINIMUM_PAYMENT = gql`
  query clientMinimumPayment($clientId: Int!, $packageId: Int!) {
    clientMinimumPayment(clientId: $clientId, packageId: $packageId) {
      requiredBalance
      daysProvided
      bsgAvailable
    }
  }
`;
